import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { EJsonQueryPriceType } from '../../../../../packages/api-models/common/json_query';

import { setPriceTypeAction } from '../../../../actions/filters';
import { FCoworkingOfferType } from '../../../../utils/category';
import { TThunkDispatch } from '../../../../types/redux';

export function useCoworkingOfferTypeChangeEffect(coworkingOfferType: FCoworkingOfferType): void {
  const dispatch = useDispatch<TThunkDispatch>();

  useEffect(() => {
    dispatch(
      setPriceTypeAction(
        (FCoworkingOfferType.FlexibleOffice & coworkingOfferType) === 0 ? EJsonQueryPriceType.Workplace : undefined,
      ),
    );
  }, [coworkingOfferType, dispatch]);
}
